<template>
    <div>
        <div class="display-value bigPaddingRound bigRoundAngles" ref="displayValue" @click="toggleOptions()" :style="'border-color:#555'">
          <span class="value-text" ref="valueText">{{options[selectedItem]}}</span>
        </div>
        <ul tabindex="0" class="select-container paddingRound bigRoundAngles" ref="selectContainer" @blur="toggleOptions()" :style="'border-color:#555'">
            <li class="select-option bigPaddingRound" v-for="(option, key) in options" @click="selected(option, key)">
              <template>
                {{option}}
              </template>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "genericCustomSelect",
        props: ['options', 'selectedItem', 'name', 'color', 'width'],
        data(){
            return {
                isOpen: false
            }
        },

      computed: {
        ...mapGetters('global', [
          'isMobile',
        ]),
      },

        methods:{
            toggleOptions: function() {
                this.isOpen = !this.isOpen;
                if (this.isOpen) {
                    this.$refs.selectContainer.style.visibility = 'visible';
                    this.$refs.selectContainer.focus();
                } else {
                    this.$refs.selectContainer.blur();
                    this.$refs.selectContainer.style.visibility = 'hidden';
                }
            },
            selected: function(val, key) {
                this.$emit('selected', key);
                this.toggleOptions();
            }
        }
    }
</script>

<style scoped>
    .display-value {
        height: fit-content;
        display: flex;
        flex-wrap: wrap;
        background: #162327;
        cursor: pointer;
        color: var(--goalColor);;
        justify-content: space-between;
      z-index: 10;
      font-size: 130%;

    }
    .display-value:hover {
        /*color: #f91e48;*/
    }
    .value-text {
        display: flex;
        align-items: center;
        font-weight: bold;
    }
    .arrow-down{
        display: flex;
        padding-right: 1.5vw;
        padding-left: 1.5vw;
        align-items: center;
    }
    .arrow {
        left: 2.5vw;
        top: 0.85vw;
        position: absolute;
    }
    .arrow.arrow-up {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid black;
    }
    .arrow.arrow-down {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid black;
    }
    .select-container {
      z-index: 10;
        max-height: 12vw;
        overflow-y: auto;
        position: absolute;
        visibility: hidden;
        margin: 0;
        height: fit-content;
        list-style-type: none;
        display: block;
        background: #162327;
      font-size: 130%;
      overflow-x: hidden;
    }
    .select-container:focus {
        outline:none;
    }
    .select-option {
        height: fit-content;
        width: calc(100% - 1vw);
        display: flex;
        align-items: center;
        color: var(--goalColor);;
    }
    .select-option:hover {
        background: var(--goalBackgroundColor);
        border-radius: 0.6vw;
        cursor: pointer;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        -webkit-border-radius: 6px;
        border-radius: 6px;
        background: var(--goalBackgroundColor);
    }

    @media screen and (max-device-width: 767px) {
      /*.display-value {
        min-width: 30vw;
      }
      .select-container {
        min-width: 30vw;
      }*/

      .select-container {
        max-height: 50vw;
      }
    }

</style>